"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const axios_1 = __importDefault(require("axios"));
const RecurrentOptionItem_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/RecurrentOptionItem.vue"));
let PreQuoteModal = class PreQuoteModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.recurrentOptionSelect = 'standard';
        this.recurrentMonitoring = true;
        this.physicoChemicalMetrics = true;
        this.state = 'default';
        this.generatingQuote = false;
    }
    mounted() {
        const element = document.getElementsByClassName('bmfw-modal--custom_prequote')[0];
        if (element) {
            element.style.maxWidth = '45rem';
            element.style.boxShadow = '0px 0px 50px rgba(0, 0, 0, 0.2)';
        }
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    updateFarmDetails(farmDetails) {
        this.$emit('updateFarmDetails', farmDetails);
    }
    async confirmInterest() {
        var _a;
        this.generatingQuote = true;
        const wholeFarmFlag = this.forWholeFarm || this.fields.length === this.farm.fields.length;
        let response;
        try {
            const url = '/farm-quoting/new-quote';
            const data = {
                entire_farm: wholeFarmFlag,
                farm_id: this.farm.id,
                gis_field_ids: this.fields.map((f) => f.gfId),
                recurrence: this.recurrentOptionNumber,
                phch_metrics_interest: this.physicoChemicalMetrics,
                preferred_unit: (_a = this.farm.preferred_unit) !== null && _a !== void 0 ? _a : this.acreageQuoted.unit,
            };
            response = await axios_1.default.post(url, data);
            this.state = 'success';
        }
        catch (e) {
            console.log(e);
            this.state = 'error';
        }
        finally {
            this.generatingQuote = false;
        }
        const responseData = {
            farmId: response.data.data.farm_id,
            details: {
                farmDetails: response.data.data.farm_details,
                quoteStatus: response.data.data.quote_status,
            },
        };
        this.updateFarmDetails(responseData);
    }
    get recurrentOptionNumber() {
        const mappingOptions = {
            standard: 1,
            enhanced: 2,
            intensive: 4
        };
        return this.recurrentMonitoring ? mappingOptions[this.recurrentOptionSelect] : 0;
    }
    get acreageQuoted() {
        var _a, _b;
        const totalAcreage = this.fields.reduce((sum, item) => sum + item.acreage.value, 0);
        return new Acreage_1.default(totalAcreage, (_b = (_a = this.fields[0]) === null || _a === void 0 ? void 0 : _a.acreage) === null || _b === void 0 ? void 0 : _b.unit);
    }
    get HA_THRESHOLD() {
        return 150;
    }
    get AC_THRESHOLD() {
        return 370;
    }
    get isAboveThreshold() {
        if (this.forWholeFarm) {
            const ac = this.farm.acreage;
            const unit = ac.unit;
            if (unit.toLowerCase().startsWith('h')) {
                if (ac.value > this.HA_THRESHOLD) {
                    return true;
                }
            }
            if (unit.toLowerCase().startsWith('a')) {
                if (ac.value > this.AC_THRESHOLD) {
                    return true;
                }
            }
        }
        return false;
    }
    back() {
        this.dismissModal();
    }
    backToTracking() {
        window.location.href = `/tracking/proposalslist/?proposal=${this.proposalEdition}`;
    }
    customQuote() {
        const url = `/farm/custom_quote?farmId=${this.farm.id}`;
        window.location.href = url;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreQuoteModal.prototype, "farm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PreQuoteModal.prototype, "forWholeFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], PreQuoteModal.prototype, "proposalEdition", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PreQuoteModal.prototype, "quoteEdition", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreQuoteModal.prototype, "fields", void 0);
PreQuoteModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            Button: bmk_ui_framework_1.Button,
            Loading: bmk_ui_framework_1.Loading,
            MessageCircle: lucide_vue_next_1.MessageCircle,
            Mail: lucide_vue_next_1.Mail,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            RecurrentOptionItem: RecurrentOptionItem_vue_1.default,
            CheckBox: bmk_ui_framework_1.CheckBox
        },
    })
], PreQuoteModal);
exports.default = PreQuoteModal;
